import React from "react";
import { Badge, Button, ModalBody } from "reactstrap";
import PageTitle from "../../PageTitle";
import { FaLink, FaPhone } from "react-icons/fa";
import { useAgent } from "../hooks/useAgent";
import Drawer from "../../../Drawer";
import Contact from "../../../Contact";
import CrossNicheLinks from "./CrossNicheLinks";

/**
 * The Agent Info card component.
 * @param {string} className - Customizable classNames.
 * @returns The content and data for the agent info card component.
 */
const AgentInfoCard = ({ className }) => {
    const {
        agent_name,
        agentTitle_part1,
        agentTitle_part2,
        isEntitled,
        brokerageName,
        agent_website_phone,
        internalAgentID,
        isOpen,
        isActive,
        toggleIsOpen,
        handlePhoneClick,
        crossNiche,
        parentAgentName,
        parentAgentUri,
        isTeamMember,
    } = useAgent();

    return (
        <>
            <div className={className} data-testid="agent-info-card">
                <div className="d-flex flex-column h-100">
                    <div className="mx-md-5">
                        <PageTitle
                            className="mb-2"
                            data-test="agent-title"
                            title={agent_name?.value}
                            titleClass="mb-0 fw-semibold"
                        />

                        <div className="my-0 mt-2">
                            {`${agentTitle_part1?.value} ${agentTitle_part2?.value}`}
                        </div>

                        {isEntitled && !isActive ? (
                            <Badge
                                className="ms-auto"
                                size="sm"
                                color="warning"
                            >
                                Inactive
                            </Badge>
                        ) : null}

                        <div>{brokerageName?.value}</div>

                        {isTeamMember && (
                            <div>{`Member of ${parentAgentName?.value}'s team`}</div>
                        )}

                        {agent_website_phone?.value && (
                            <div data-test="agent-phone">
                                <Button
                                    color="link"
                                    className="d-flex align-items-center m-0 px-0"
                                    href={`tel:${agent_website_phone?.value}`}
                                    onClick={() => handlePhoneClick()}
                                >
                                    <div>
                                        <FaPhone
                                            className="me-2"
                                            size="12"
                                            style={{
                                                marginTop: "-4px",
                                            }}
                                        />
                                    </div>

                                    <div>{agent_website_phone?.value}</div>
                                </Button>
                            </div>
                        )}

                        {crossNiche && crossNiche.length > 0 && (
                            <CrossNicheLinks
                                crossNiche={crossNiche}
                                agent_name={agent_name}
                            />
                        )}

                        {isTeamMember && (
                            <>
                                <div>
                                    <Button
                                        color="link"
                                        className="d-flex align-items-center m-0 px-0"
                                        href={parentAgentUri?.value}
                                    >
                                        <div>
                                            <FaLink
                                                className="me-2"
                                                size="12"
                                                style={{
                                                    marginTop: "-4px",
                                                }}
                                            />
                                        </div>

                                        <div>{`View ${parentAgentName?.value}'s page`}</div>
                                    </Button>
                                </div>
                            </>
                        )}
                    </div>

                    <div className="mt-auto mx-auto">
                        <Button
                            color="primary"
                            className="fw-medium btn-lg"
                            onClick={() => toggleIsOpen()}
                        >
                            Contact
                        </Button>
                    </div>
                </div>
            </div>

            <Drawer isOpen={isOpen} toggle={() => toggleIsOpen()}>
                <ModalBody data-testid="agent-contact-drawer">
                    <Contact agentId={internalAgentID} />
                </ModalBody>
            </Drawer>
        </>
    );
};

export default AgentInfoCard;
